import isArrayLike from './is-array-like';
export default function head(o) {
    if (isArrayLike(o)) {
        return o[0];
    }
    return undefined;
}
//# sourceMappingURL=head.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/esm/head.js
// module id = null
// module chunks = 